
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "AlertTriggerToggle",
})
export default class AlertTriggerToggle extends Vue {
  @Prop({ type: String, required: false, default: "de" })
  private readonly locale!: string;
  @Prop({ type: String, required: true })
  private readonly idNotation!: string;
  @Prop({ type: Boolean, required: false })
  private readonly hasIconTitle!: boolean;
  public onControlClick() {
    window.dispatchEvent(
      new CustomEvent("alert-trigger-toggle-control-clicked", {
        detail: this.idNotation,
      })
    );
  }
}
